import { BADGE_LABEL_COLORS, BadgeLabelColorType } from '@hevoio/hevo-ui-toolkit';

export const WORKSPACE_STATUS_LABELS: Record<string, string> = {
  Active: 'Active',
  Deleted: 'Deleted',
  SetupIncomplete: 'Setup Incomplete'
};

export const WORKSPACE_STATUS_BADGE_COLORS: Record<string, BadgeLabelColorType> = {
  Active: BADGE_LABEL_COLORS.SUCCESS,
  Deleted: BADGE_LABEL_COLORS.ERROR,
  SetupIncomplete: BADGE_LABEL_COLORS.WARNING
};
